export const TOGGLE_FAVOURITE = "TOGGLE_FAVOURITE";
export const ADD_TO_FAVOURITES = "ADD_TO_FAVOURITES";
export const REMOVE_FROM_FAVOURITES = "REMOVE_FROM_FAVOURITES";
export const SET_FAVOURITES = "SET_FAVOURITES";

export const TOGGLE_EX_OUT = "TOGGLE_EX_OUT";
export const ADD_TO_EX_OUT = "ADD_TO_EX_OUT";
export const REMOVE_FROM_EX_OUT = "REMOVE_FROM_EX_OUT";
export const SET_EX_OUT = "SET_EX_OUT";
